module.exports = __webpack_public_path__ + "img/1546339752.0b44e0ee.jpg";